__turbopack_context__.v({
  "button": "ErrorModalFooter-module-scss-module__XxjutG__button",
  "buttonText": "ErrorModalFooter-module-scss-module__XxjutG__buttonText",
  "secondary": "ErrorModalFooter-module-scss-module__XxjutG__secondary",
});
